<script lang="ts" setup>
import { UISkeleton } from '@gohighlevel/ghl-ui'
</script>
<template>
  <div class="flex flex-row gap-2">
    <div
      class="flex h-[48px] w-[48px] flex-col items-center justify-center gap-0 rounded-md bg-communities-border p-0 text-center"
    />
    <div class="flex flex-col justify-center gap-2">
      <UISkeleton
        height="17px"
        width="140px"
        :sharp="false"
        class="rounded-md"
      />
      <span class="flex flex-row gap-1 text-communities-font-secondary">
        <UISkeleton
          height="15px"
          width="100px"
          :sharp="false"
          class="rounded-md"
        />
        <UISkeleton
          height="15px"
          width="100px"
          :sharp="false"
          class="rounded-md"
        />
      </span>
    </div>
  </div>
</template>
